import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom"

import Style from "./style"

import PageTitle from "widget/PageTitle"
import DefaultButton from "shared/ui/DefaultButton"

import useGetMyExamList from "entity/tryoutExam/useGetMyExamList"

import timestampCalculator from "shared/lib/timestampCalculator"
import { convertProGradeAsName } from "shared/constant/lookup/proGrade"
import useLoginCookie from "shared/model/useLoginCookie";

const MyTryoutRecord = () => {
    const navigate = useNavigate()

    const [getMyExamList] = useGetMyExamList()
    const [cookie, , deleteCookie] = useLoginCookie();
    
    const [fetchData, setFetchData] = useState([]);
    const [fetchStatus, setFetchStatus] = useState([]);

    useEffect(() => {
    (async () => {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/tryout/payment/practical/list/my`,
        {
          method: "GET",
          headers: {
            token: cookie,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        setFetchStatus(response.status);
        return;
      }

      const jsonData = await response.json();
      //   practical_payment_exam_list: [{idx: 2, exam_payment_record_idx: 14}, .....]
      setFetchData(jsonData.practical_payment_exam_list);
    })();
  }, []);


    return (
        <Style.Wrapper>
            <PageTitle>내 트라이아웃 필기 시험</PageTitle>

            <Style.RecordList>
                {/* {getMyExamList?.data?.payment_exam_list?.map(elem =>
                    <Style.RecordElement>
                        <h2>{convertProGradeAsName[elem?.pro_grade_flag]} 프로 필기 시험</h2>
                        <h3>Version {elem?.version} | 결제일 {timestampCalculator(elem?.created_at)}</h3>
                        {elem?.is_pass !== null
                            ? <p>{elem?.grade} 점 | <span>{elem?.is_pass ? "합격" : "불합격"}</span></p>
                            : <div>
                                <DefaultButton clickEvent={() => navigate(`/tryout/payment/${elem?.idx}/taking`)}>응시하기</DefaultButton>
                            </div>
                        }
                        <DefaultButton small clickEvent={() => navigate(`/event?page=1&managerIdx=${elem.manager_idx}&eventTypeFlag=4&eventStateFlag=1`)} deactive={!elem?.is_pass}>실기 응시하기</DefaultButton>
                    </Style.RecordElement>
                )}
                {getMyExamList?.data?.payment_exam_list?.length < 1 && <Style.Option>결제된 필기 시험이 없습니다.</Style.Option>} */}

                 {getMyExamList?.data?.payment_exam_list?.map(elem => {
                    // 실기 결제 내역 중 현재 필기 시험(elem)에 해당하는 것이 있는지 확인
                    const hasPracticalPayment = fetchData.some(
                        (practicalElem) => practicalElem.exam_payment_record_idx === elem.idx
                    );

                    // '실기 응시하기' 버튼 deactive 여부 결정
                    // 1. 필기 시험에 합격하지 않았거나 (is_pass가 false)
                    // 2. 이미 해당 필기 시험에 대한 실기 결제 내역이 있는 경우
                    const isPracticalButtonDeactive = !elem?.is_pass || hasPracticalPayment;

                    return (
                        <Style.RecordElement key={elem.idx}> {/* key prop 추가 권장 */}
                            <h2>{convertProGradeAsName[elem?.pro_grade_flag]} 프로 필기 시험 - {elem?.store_name}</h2>
                            <h3>{elem?.version}회차 | 결제일 {timestampCalculator(elem?.created_at)}</h3>
                            {elem?.is_pass !== null
                                ? <p>{elem?.grade} 점 | <span>{elem?.is_pass ? "합격" : "불합격"}</span></p>
                                : <div>
                                    <DefaultButton clickEvent={() => navigate(`/tryout/payment/${elem?.idx}/taking`)}>응시하기</DefaultButton>
                                </div>
                            }
                            {/* isPracticalButtonDeactive 변수를 사용하여 deactive prop 제어 */}
                            <DefaultButton
                                small
                                clickEvent={() => navigate(`/event?page=1&managerIdx=${elem.manager_idx}&eventTypeFlag=4&eventStateFlag=1`)}
                                deactive={isPracticalButtonDeactive}
                            >
                                실기 응시하기
                            </DefaultButton>
                        </Style.RecordElement>
                    );
                })}
                {getMyExamList?.data?.payment_exam_list?.length < 1 && <Style.Option>결제된 필기 시험이 없습니다.</Style.Option>}
            </Style.RecordList>

        </Style.Wrapper>
    )
}

export default MyTryoutRecord